import { createSlice } from "@reduxjs/toolkit";

const initialSlice = {
  isDropdownOpen: false,
};

const profileIconSlice = createSlice({
  name: "profileIcon",
  initialState: initialSlice,
  reducers: {
    toggleDropdown: (state) => {
      state.isDropdownOpen = !state.isDropdownOpen;
    },
  },
});

export const { toggleDropdown } = profileIconSlice.actions;
export default profileIconSlice.reducer;
